import React, { Component } from 'react';
import { Redirect } from 'react-router';
import AuthContext from '../../contexts/AuthContext';

class Logout extends Component {

    static contextType = AuthContext;

    render() {
        return (
            <Redirect to='/' />
        )
    }

    componentDidMount() {
        this.context.logout();
    }

}

export default Logout;